import React from 'react'

const ProductIndexPage = () => {
  return (
    <div>ProductIndexPage</div>
  )
}

export default ProductIndexPage